/**
 * @file
 * @auth jinguangguo
 * @date 2016/10/19
 */



const DEFAULT_TYPE = 'GET';
const DEFAULT_TIMEOUT = 30000;

export default {

  /**
   * 发送请求
   * @param method
   * @param params
   * @returns {*}
   */
  send(method, params = {}) {
    let deferred = $.Deferred();

    let reqData = {
      jsonrpc: '2.0',
      id: new Date().getTime(),
      method: method,
      params: params
    };

    // console.log(method);
    // console.log(params);

    var query_params = {
      page: "1"
      , per_page: "13"
    };

    var query_string = "";

    if (method == "Statistic.Transaction") {
      return deferred.promise();
    }


    if (method != "Statistic.Transaction") {
      query_string = "?" + Object.keys(query_params).map(key => key + '=' + query_params[key]).join('&');
    }

    let ajax_url = '/api/browser/ttc/' + method + query_string;
    // url: 'http://1.201.140.92:8080/api/browser/ttc/Block.Query?page=1&per_page=13',

    $.ajax({
      url: ajax_url,
      // data: JSON.stringify(reqData),
      type: DEFAULT_TYPE,
      dataType: 'JSON',
      contentType: 'application/json; charset=UTF-8',
      async: true,
      timeout: DEFAULT_TIMEOUT,
      success: function (rep) {

        // console.log(rep);

        if (rep.error) {
          // 报错了
          deferred.rejectWith(this, ['网络异常, 请稍候再试']);
        } else {
          // 正确
          deferred.resolveWith(this, [rep]);
        }
      },
      error: function (xhr, type) {

      }
    });

    return deferred.promise();
  }

};


// WEBPACK FOOTER //
// ./src/util/ajax.js